import { render } from "./admin-payment.vue?vue&type=template&id=3c5cb831"
import script from "./admin-payment.vue?vue&type=script&lang=js"
export * from "./admin-payment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__